var isObject = require('../internals/is-object');

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/an-object.js
// module id = 42
// module chunks = 0